"use strict";

const VISIBLE_CLASS = "visible";
const ACTIVE_MESSAGE_CLASS = "js-message-active";

const SELECTORS = {
	MESSAGE: ".js-message",
	MESSAGE_BUTTON: ".js-message__close",
	BODY: "body",
	CONTAINER: ".js-alert"
};

function showMessage(elem) {
    document.querySelector(SELECTORS.BODY).classList.add(ACTIVE_MESSAGE_CLASS);
    elem.classList.add(VISIBLE_CLASS);
}

function hideMessage(elem) {
    elem.classList.remove(VISIBLE_CLASS);
    if (document.querySelectorAll(`${SELECTORS.MESSAGE}.${VISIBLE_CLASS}`).length === 0) {
        document.querySelector(SELECTORS.BODY).classList.remove(ACTIVE_MESSAGE_CLASS);
    }
}

export function init() {
	const messages = document.querySelectorAll(SELECTORS.MESSAGE);
    const container = document.querySelector(SELECTORS.CONTAINER);

	if (messages.length === 0) {
		return false;
	}

	if (messages.length) {
        let alertHeight = container.clientHeight;

        window.addEventListener('resize', () => {
            alertHeight = container.clientHeight;
            document.documentElement.style.setProperty('--alert-height', `${alertHeight}px`);
        });

		messages.forEach(message => {
			const messageId = message.getAttribute("data-message-id");
			const messageStorageKey = "app.message-hidden-" + messageId;
			const messageButton = message.querySelector(SELECTORS.MESSAGE_BUTTON);
			let isHidden;

			try {
				isHidden = localStorage.getItem(messageStorageKey);
			} catch (e) {
				console.warn(e);
			}

			if (!isHidden) {
				showMessage(message);
			}


            alertHeight = container.clientHeight;
            document.documentElement.style.setProperty('--alert-height', `${alertHeight}px`);

			messageButton.addEventListener("click", function (evt) {
				evt.preventDefault();
				hideMessage(message);
                alertHeight = container.clientHeight;
                document.documentElement.style.setProperty('--alert-height', `${alertHeight}px`);

				try {
					localStorage.setItem(messageStorageKey, true);
				} catch (e) {
					console.warn(e);
				}
			});
		});
	}
}
